import { FC } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { AvatarProps } from './types';
import { selectAuthUser } from '../../store/selectors/auth';
import { getInitials } from '../../utils/getInitials';

import styles from './Avatar.module.css';



const sizeClasses = {
  md: styles['is-md'],
  lg: styles['is-lg']
};




const Avatar: FC<AvatarProps> = ({
  size = 'md',
  className
}) => {
  const user = useSelector(selectAuthUser);
  if (!user) return null;

  const avatarUrl = user.user_metadata.avatar_url;
  const fullName = user.user_metadata.full_name;
  const initials = getInitials(fullName);

  return (
    <div className={classNames(styles["avatar"], sizeClasses[size], className)}>
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt={fullName}
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
};

export default Avatar;
